import {
  Box,
  CircularProgress,
  Switch,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeStyles, styled } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { ApiContainer } from "../../utils/api";

const useStyles = makeStyles((theme) => ({
  assessmentTableCard: {},
}));

const AntSwitch = styled(Switch)(({ theme }) => ({
  "&.MuiSwitch-root": {
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "var(--white)",
        "& + .MuiSwitch-track": {
          opacity: 1,
          background: "var(--Tertiary)",
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.3,
          background: "var(--Tertiary)",
        },
      },
      "& + .MuiSwitch-track": {
        background: "#00000040",
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: "all 0.4s ease-in-out",
    },
    "& .MuiSwitch-track": {
      borderRadius: 10,
      opacity: 1,
      boxSizing: "border-box",
    },
  },
}));

export default function WaiverExpandRow({ orgId, data }) {
  const dataOfWawierAccess = useSelector(
    (state) => state.api?.dataOfWawierAccess?.assessments
  );
  const classes = useStyles();
  const { api } = ApiContainer();
  const [waivers, setWaivers] = useState([]);

  useEffect(() => {
    if (dataOfWawierAccess) {
      setWaivers(dataOfWawierAccess);
    }
  }, [dataOfWawierAccess]);

  const onSwitchChange = async (event, item) => {
    const isChecked = event.target.checked;

    const updatedWaivers = waivers?.map((waiver) =>
      waiver.id === item.id ? { ...waiver, is_assign: isChecked } : waiver
    );
    setWaivers(updatedWaivers);

    const updatedStateArray = updatedWaivers
      ?.filter((waiver) => waiver.is_assign)
      ?.map((waiver) => waiver.id);

    const data = await api({
      method: "POST",
      endPoint: `platform-admin/organization/${orgId}/waivers`,
      data: {
        assigned_waivers: updatedStateArray,
      },
      showToastMessage: true,
      urlencoded: false,
    });

    if (!data.status) {
      setWaivers((prevWaivers) =>
        prevWaivers?.map((waiver) =>
          waiver.id === item.id ? { ...waiver, is_assign: !isChecked } : waiver
        )
      );
    }
  };

  return (
    <>
      {!dataOfWawierAccess ? (
        <Box
          sx={{
            textAlign: "center",
            height: 45,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress size={24} color="inherit" />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Waiver Name</TableCell>
                <TableCell>Required</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {waivers?.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item?.name || "N/A"}</TableCell>
                  <TableCell align="center">
                    <AntSwitch
                      sx={item?.nonChangeable ? { pointerEvents: "none" } : {}}
                      disabled={item?.nonChangeable}
                      checked={item?.is_assign || false}
                      onChange={(event) =>
                        !item?.nonChangeable
                          ? onSwitchChange(event, item)
                          : null
                      }
                      inputProps={{ "aria-label": "ant design" }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
